import type { ExtensionType } from '@blocksuite/store';

import {
  RichTableBlockHtmlAdapterExtension,
  RichTableCellBlockHtmlAdapterExtension,
  RichTableRowBlockHtmlAdapterExtension,
} from './html.js';
import { RichTableBlockMarkdownAdapterExtension } from './markdown.js';

export const RichTableBlockAdapterExtensions: ExtensionType[] = [
  RichTableBlockMarkdownAdapterExtension,
  RichTableBlockHtmlAdapterExtension,
  RichTableRowBlockHtmlAdapterExtension,
  RichTableCellBlockHtmlAdapterExtension,
];
